/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  DeleteProjectParams,
  HTTPValidationError,
  ProMyProjectsResponse,
  RepMyProjectsResponse,
  UnsaveProjectParams,
  UpdateProjectDatesModel,
} from './platformapi.schemas';

import countUserActionItemsMutator from '../custom-axios-instance';
import deleteProjectMutator from '../custom-axios-instance';
import getOrgUserMyProjectsMutator from '../custom-axios-instance';
import getProUserMyProjectsMutator from '../custom-axios-instance';
import updateProjectDatesMutator from '../custom-axios-instance';
import unsaveProjectMutator from '../custom-axios-instance';

/**
 * API returning the count of projects with action items on the My Projects page

Currently indicates # of important items to be addressed as a # indicator in the left hand nav of My Projects

Should indicate the # of intros awaiting the current user's response, + the # of discoveries awaiting the current user's response, + the # of projects missing any of plan, action or reflect (survey) steps
 * @summary Count User Action Items
 */
export const countUserActionItems = (signal?: AbortSignal) => {
  return countUserActionItemsMutator<number>({
    url: `${import.meta.env['VITE_API_HOST']}/count-action-items`,
    method: 'GET',
    signal,
  });
};

export const getCountUserActionItemsQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/count-action-items`] as const;
};

export const getCountUserActionItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof countUserActionItems>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof countUserActionItems>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCountUserActionItemsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof countUserActionItems>>> = ({ signal }) =>
    countUserActionItems(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof countUserActionItems>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CountUserActionItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof countUserActionItems>>
>;
export type CountUserActionItemsQueryError = void | HTTPValidationError;

export function useCountUserActionItems<
  TData = Awaited<ReturnType<typeof countUserActionItems>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countUserActionItems>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof countUserActionItems>>,
          TError,
          Awaited<ReturnType<typeof countUserActionItems>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCountUserActionItems<
  TData = Awaited<ReturnType<typeof countUserActionItems>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countUserActionItems>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof countUserActionItems>>,
          TError,
          Awaited<ReturnType<typeof countUserActionItems>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCountUserActionItems<
  TData = Awaited<ReturnType<typeof countUserActionItems>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countUserActionItems>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Count User Action Items
 */

export function useCountUserActionItems<
  TData = Awaited<ReturnType<typeof countUserActionItems>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof countUserActionItems>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCountUserActionItemsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Delete a project and all related data
 * @summary Delete Project
 */
export const deleteProject = (params: DeleteProjectParams) => {
  return deleteProjectMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/delete-project`,
    method: 'DELETE',
    params,
  });
};

export const getDeleteProjectMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProject>>,
    TError,
    { params: DeleteProjectParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProject>>,
  TError,
  { params: DeleteProjectParams },
  TContext
> => {
  const mutationKey = ['deleteProject'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProject>>,
    { params: DeleteProjectParams }
  > = (props) => {
    const { params } = props ?? {};

    return deleteProject(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteProjectMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProject>>>;

export type DeleteProjectMutationError = void | HTTPValidationError;

/**
 * @summary Delete Project
 */
export const useDeleteProject = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteProject>>,
      TError,
      { params: DeleteProjectParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteProject>>,
  TError,
  { params: DeleteProjectParams },
  TContext
> => {
  const mutationOptions = getDeleteProjectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Org User My Projects
 */
export const getOrgUserMyProjects = (signal?: AbortSignal) => {
  return getOrgUserMyProjectsMutator<RepMyProjectsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/my-projects-org`,
    method: 'GET',
    signal,
  });
};

export const getGetOrgUserMyProjectsQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/my-projects-org`] as const;
};

export const getGetOrgUserMyProjectsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrgUserMyProjects>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrgUserMyProjects>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrgUserMyProjectsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgUserMyProjects>>> = ({ signal }) =>
    getOrgUserMyProjects(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrgUserMyProjects>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrgUserMyProjectsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrgUserMyProjects>>
>;
export type GetOrgUserMyProjectsQueryError = void | HTTPValidationError;

export function useGetOrgUserMyProjects<
  TData = Awaited<ReturnType<typeof getOrgUserMyProjects>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrgUserMyProjects>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgUserMyProjects>>,
          TError,
          Awaited<ReturnType<typeof getOrgUserMyProjects>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrgUserMyProjects<
  TData = Awaited<ReturnType<typeof getOrgUserMyProjects>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrgUserMyProjects>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgUserMyProjects>>,
          TError,
          Awaited<ReturnType<typeof getOrgUserMyProjects>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrgUserMyProjects<
  TData = Awaited<ReturnType<typeof getOrgUserMyProjects>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrgUserMyProjects>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Org User My Projects
 */

export function useGetOrgUserMyProjects<
  TData = Awaited<ReturnType<typeof getOrgUserMyProjects>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrgUserMyProjects>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrgUserMyProjectsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Pro User My Projects
 */
export const getProUserMyProjects = (signal?: AbortSignal) => {
  return getProUserMyProjectsMutator<ProMyProjectsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/my-projects-pro`,
    method: 'GET',
    signal,
  });
};

export const getGetProUserMyProjectsQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/my-projects-pro`] as const;
};

export const getGetProUserMyProjectsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProUserMyProjects>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProUserMyProjects>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProUserMyProjectsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProUserMyProjects>>> = ({ signal }) =>
    getProUserMyProjects(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProUserMyProjects>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProUserMyProjectsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProUserMyProjects>>
>;
export type GetProUserMyProjectsQueryError = void | HTTPValidationError;

export function useGetProUserMyProjects<
  TData = Awaited<ReturnType<typeof getProUserMyProjects>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProUserMyProjects>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProUserMyProjects>>,
          TError,
          Awaited<ReturnType<typeof getProUserMyProjects>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProUserMyProjects<
  TData = Awaited<ReturnType<typeof getProUserMyProjects>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProUserMyProjects>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProUserMyProjects>>,
          TError,
          Awaited<ReturnType<typeof getProUserMyProjects>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProUserMyProjects<
  TData = Awaited<ReturnType<typeof getProUserMyProjects>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProUserMyProjects>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Pro User My Projects
 */

export function useGetProUserMyProjects<
  TData = Awaited<ReturnType<typeof getProUserMyProjects>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProUserMyProjects>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProUserMyProjectsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * API to update project dates
 * @summary Update Project Dates
 */
export const updateProjectDates = (
  updateProjectDatesModel: UpdateProjectDatesModel,
  signal?: AbortSignal,
) => {
  return updateProjectDatesMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/project-dates`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateProjectDatesModel,
    signal,
  });
};

export const getUpdateProjectDatesMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProjectDates>>,
    TError,
    { data: UpdateProjectDatesModel },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProjectDates>>,
  TError,
  { data: UpdateProjectDatesModel },
  TContext
> => {
  const mutationKey = ['updateProjectDates'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProjectDates>>,
    { data: UpdateProjectDatesModel }
  > = (props) => {
    const { data } = props ?? {};

    return updateProjectDates(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProjectDatesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProjectDates>>
>;
export type UpdateProjectDatesMutationBody = UpdateProjectDatesModel;
export type UpdateProjectDatesMutationError = void | HTTPValidationError;

/**
 * @summary Update Project Dates
 */
export const useUpdateProjectDates = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateProjectDates>>,
      TError,
      { data: UpdateProjectDatesModel },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateProjectDates>>,
  TError,
  { data: UpdateProjectDatesModel },
  TContext
> => {
  const mutationOptions = getUpdateProjectDatesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * API for unfollowing an opportunity
 * @summary Unsave Project
 */
export const unsaveProject = (params: UnsaveProjectParams, signal?: AbortSignal) => {
  return unsaveProjectMutator<boolean>({
    url: `${import.meta.env['VITE_API_HOST']}/unsave-opportunity`,
    method: 'POST',
    params,
    signal,
  });
};

export const getUnsaveProjectMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unsaveProject>>,
    TError,
    { params: UnsaveProjectParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unsaveProject>>,
  TError,
  { params: UnsaveProjectParams },
  TContext
> => {
  const mutationKey = ['unsaveProject'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unsaveProject>>,
    { params: UnsaveProjectParams }
  > = (props) => {
    const { params } = props ?? {};

    return unsaveProject(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnsaveProjectMutationResult = NonNullable<Awaited<ReturnType<typeof unsaveProject>>>;

export type UnsaveProjectMutationError = void | HTTPValidationError;

/**
 * @summary Unsave Project
 */
export const useUnsaveProject = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof unsaveProject>>,
      TError,
      { params: UnsaveProjectParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof unsaveProject>>,
  TError,
  { params: UnsaveProjectParams },
  TContext
> => {
  const mutationOptions = getUnsaveProjectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
